import {animate, animation, AnimationReferenceMetadata, style} from '@angular/animations';

export const fadeAnimation: AnimationReferenceMetadata = animation([
    style({opacity: '{{ start }}'}),
    animate('{{ time }}',
      style({opacity: '{{ end }}'}))
  ],
  {params: {time: '1000ms', start: 0, end: 1}});
